import FeatsDetail from "./FeatsDetail";

export default FeatsDetail;
export { FeatsDetail };
